"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _utils = require("@/utils");
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'likeCommentList',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currentItem: {},
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        empName: '',
        startTime: '',
        endTime: ''
      },
      errorKeys: [],
      errorInfo: {},
      exportUrl: '/protected/app/message/like_and_comment_export'
    };
  },
  computed: {},
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
    }
  },
  mounted: function mounted() {
    this.searchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.likeComment.getList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = {};
      this.searchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    exportHandler: function exportHandler() {
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.exportReport(param);
    },
    exportReport: function exportReport(param) {
      var _this2 = this;
      if (this.isLoading) return;
      this.isLoading = true;
      var promiseFn = this.$api.likeComment.exportReportFile;
      var fileName = this.$t("sfe.route.likeComment");
      promiseFn(this.exportUrl, param).then(function (res) {
        _this2.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function () {
        _this2.isLoading = false;
      });
    },
    querySearchAsync: function querySearchAsync(query, cb) {
      if (query.trim() !== '') {
        var param = {
          empName: query
        };
        (0, _doubleWeekPlan.queryAllEmpList)(param).then(function (res) {
          cb(res.data);
        });
      } else {
        cb([]);
      }
    },
    handleSelect: function handleSelect(item) {
      this.searchVal.empName = item.empName;
      this.searchVal.empNo = item.empNo;
    },
    changeInput: function changeInput() {
      this.searchVal.empNo = item.empNo;
    }
  }
};